/**
 * The one-line install command for the Dixie daemon. Points at THIS
 * deployment's host (prod → dixie.thegp.com, dev → localhost); the server
 * rewrites install.sh's own base URL to match, so the daemon it installs
 * uploads to wherever the dashboard is served from.
 *
 * Single source of truth for the three surfaces that show it — the /setup
 * wizard, the Settings CLI block, and the Home ConnectDixiePanel — so the
 * command can never drift between them.
 */
export function installCommand(): string {
  return `curl -fsSL ${window.location.origin}/install.sh | sh`;
}
